import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { titleCase } from "jsx/helpers";
import React from "react";
import { useHistory } from "react-router-dom";

export default function SecondaryTransactionTable({
  transactions,
  secondaryId,
  loading,
}) {
  const history = useHistory();

  const columns = [
    {
      field: "seller",
      headerName: "Seller",
      flex: 140,
      renderCell: (cellValues) => {
        return (
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ flexShrink: 1 }}>{cellValues.formattedValue}</div>
            <div style={{ width: "30px" }}>
              <FontAwesomeIcon
                icon={regular("arrow-right")}
                style={{ marginLeft: 8, float: "right", marginTop: 3 }}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "buyer",
      headerName: "Buyer",
      flex: 140,
    },
    {
      field: "certificateNo",
      headerName: "Security",
      flex: 80,
      valueFormatter: ({ value }) => value ?? "-",
    },

    {
      field: "quantity",
      headerName: "Quantity",
      type: "number",
      flex: 80,
      valueFormatter: ({ value }) => value && value.toLocaleString(),
      align: "right",
      headerAlign: "right",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 100,
      valueFormatter: ({ value }) => value && titleCase(value),
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return <div className="pill py-1">{cellValues.formattedValue}</div>;
      },
    },
  ];

  const transactionRows = transactions.map((transaction, i) => {
    return {
      id: transaction.id,
      buyer: transaction.buyerName,
      seller: transaction.sellerName,
      certificateNo: transaction.securityDetails.certificateNo,
      quantity: transaction.quantity,
      status: transaction.status,
    };
  });

  return (
    <div>
      <div style={{ width: "100%" }}>
        <DataGridPro
          rows={transactionRows}
          columns={columns}
          pageSize={100}
          disableColumnMenu
          hideFooter={true}
          autoHeight={true}
          loading={loading}
          key={loading}
          onCellClick={(param) => {
            history.push(
              `/org/secondaries/manage/${secondaryId}/transactions/${param.id}`
            );
          }}
          sx={{
            borderColor: "var(--purple-light)",

            "& .MuiDataGrid-cell": {
              borderBottomColor: "var(--purple-light)",
              fontFamily: "var(--primary-font)",
              fontSize: 14,
              fontWeight: 400,
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: 13,
              fontFamily: "var(--primary-font)",
              color: "#6c757d",
            },
            "& .MuiDataGrid-columnHeaders": {
              borderBottomColor: "var(--purple-light)",
            },
            "& .MuiDataGrid-row:hover": {
              // background: "#FFF",
              background: "var(--background)",
              cursor: "pointer",
            },
            "& .MuiDataGrid-columnSeparator": {
              visibility: "hidden",
            },
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "& .MuiDataGrid-columnHeader:focus": {
              outline: "none",
            },
            "& .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
          }}
        />
      </div>
    </div>
  );
}
